import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import VContactForm from '../components/VContactForm.vue'
import VProducts from '../components/VProducts.vue'
import VServicesArticles from '../components/VServicesArticles.vue'

createApp({
  components: {
    VContactForm,
    VProducts,
    VServicesArticles
  },
  extends: app,
  mixins: [errorMixin]
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
